import { useLocation } from 'react-router-dom'

export const useGetQueryParam = (queryString: string): string | undefined => {
  const location = useLocation().search
  const query = new URLSearchParams(location)
  const paramValue = query.get(queryString)

  return !paramValue ? undefined : paramValue
}
